/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { UnitAcquisitionSearchBody } from '../../models/unit-acquisition-search-body';
import { UnitAcquisitionSortFieldName } from '../../models/unit-acquisition-sort-field-name';
import { UnitAcquisitionStatePagedList } from '../../models/unit-acquisition-state-paged-list';

export interface SearchUnitsAcquisitionParameters$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;
  sortFieldName?: UnitAcquisitionSortFieldName;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search units acquisition parameters
     */
    body?: UnitAcquisitionSearchBody
}

export function searchUnitsAcquisitionParameters$Json(http: HttpClient, rootUrl: string, params?: SearchUnitsAcquisitionParameters$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitAcquisitionStatePagedList>> {
  const rb = new RequestBuilder(rootUrl, searchUnitsAcquisitionParameters$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnitAcquisitionStatePagedList>;
    })
  );
}

searchUnitsAcquisitionParameters$Json.PATH = '/units/acquisition-parameters/search';
